export type FreightDetailRow = {
  amount: number | null;
  length: number | null;
  width: number | null;
  height: number | null;
  toggle1: boolean;
  weightPerPiece: number | null;
  toggle2: boolean;
  stackable: string | null;
};

export const DEFAULT_FREIGHT_ROW: FreightDetailRow = {
  amount: null,
  length: null,
  width: null,
  height: null,
  toggle1: true,
  weightPerPiece: null,
  toggle2: true,
  stackable: null,
} as const;
export const FREIGHT_LABELS: string[] = [
  "quotationTool.chargeableWeight.amount",
  "quotationTool.chargeableWeight.length",
  "quotationTool.chargeableWeight.width",
  "quotationTool.chargeableWeight.height",
  "",
  "quotationTool.chargeableWeight.weightPerPiece",
  "",
  "quotationTool.chargeableWeight.stackable",
];

export type QuotationData = {
  customer: string;
  pickup: AddressInformation;
  delivery: AddressInformation;
  availableFrom: Date | null;
  dueDate?: Date | null;
  chargeWeight: ChargeWeightInformation;
  additionalInformation: AdditionalInformation;
  price?: number;
  serviceType?: string;
};

export type AddressInformation = {
  addressNr: string;
  company: string;
  address: string;
  zip: string;
  city: string;
  country: string;
};

export type ChargeWeightInformation = {
  totalVolume: number;
  totalWeight: number;
  metricMeasurement?: boolean;
  metricVolumeMeasurement?: boolean;
  cwAir: number;
  cwTruck: number;
  cwOcean: number;
  cwCourier: number;
  freightDetailRows?: FreightDetailRow[];
  huSum?: number;
};

export type AdditionalInformation = {
  incoterm: (typeof INCOTERMS)[number];
  hasDangerousGoods: boolean;
  hasInsurance: boolean;
  remarks: string;
  valueOfGoods: number;
  currency: "EUR" | "USD" | "MXN";
};

export type Currency = {
  currency: "EUR" | "USD" | "MXN";
};

export type LocationData = {
  location: string;
  address1: string;
  address2: string | null;
  address3: string | null;
  id: number;
  locality: string;
  postal_code: string;
  thoroughfare: string;
  country: string;
};

export type PortDetails = {
  nameDE: string;
  countryDE: string;
  nameEN: string;
  countryEN: string;
};

export type Transport = {
  type: "AIR" | "TRUCK" | "OCEAN" | "COURIER";
  pol: PortDetails;
  pod: PortDetails;
  estTransitTime: number;
  price?: number;
  serviceType?: string;
  currency?: string;
  transitId: string;
};

export const INCOTERMS = [
  "EXW",
  "FCA",
  "CPT",
  "CIP",
  "DAP",
  "DPU",
  "DDP",
  "FAS",
  "FOB",
  "CFR",
  "CIF",
];
